import React from 'react';

const fmtDate = (d) => (d ? new Date(d).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }) : '');

/**
 * Shown on a payment that was reversed because its cheque was cancelled from the cheque book
 * (payment.reversal set by the reversal flow).
 */
const PaymentReversalBanner = ({ reversal, className = '' }) => {
  if (!reversal?.reversedAt) return null;
  return (
    <div className={`flex items-start gap-2 px-3 py-2 rounded-lg border border-red-200 bg-red-50 text-sm text-red-800 ${className}`}>
      <svg className="w-4 h-4 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
      </svg>
      <div>
        <p className="font-medium">
          Reversed on {fmtDate(reversal.reversedAt)}
          {reversal.chequeNumber ? ` — cheque ${reversal.chequeNumber} cancelled` : ''}
        </p>
        <p className="text-xs">
          {reversal.reason || ''}
          {(reversal.reversalDocCode || reversal.reversalTransactionId?.docCode)
            ? ` · Reversing entry ${reversal.reversalDocCode || reversal.reversalTransactionId.docCode}${reversal.reversalDate ? ` dated ${fmtDate(reversal.reversalDate)}` : ''}`
            : reversal.reversalDate ? ` · Reversing entry dated ${fmtDate(reversal.reversalDate)}` : ' · Not posted — no ledger entry to reverse'}
        </p>
      </div>
    </div>
  );
};

export default PaymentReversalBanner;
